export default __webpack_public_path__ + "static/text-hero-settings-d6b444a69a8d96ab9afb671342aa2451.png";